export interface TableRangeFilterConfig {
    maxValue: number
    maxDigits: number
    containerClassName: string
}

export const TABLE_RANGE_FILTER_CONFIG: Record<
    'persons' | 'persons_reserved' | 'persons_effective' | 'value' | 'total' | 'total_invoice',
    TableRangeFilterConfig
> = {
    persons: {
        maxValue: 9999,
        maxDigits: 4,
        containerClassName: 'max-w-[180px]',
    },
    persons_reserved: {
        maxValue: 9999,
        maxDigits: 4,
        containerClassName: 'max-w-[180px]',
    },
    persons_effective: {
        maxValue: 9999,
        maxDigits: 4,
        containerClassName: 'max-w-[180px]',
    },
    value: {
        maxValue: 99999,
        maxDigits: 5,
        containerClassName: 'max-w-[200px]',
    },
    total: {
        maxValue: 99999,
        maxDigits: 5,
        containerClassName: 'max-w-[200px]',
    },
    total_invoice: {
        maxValue: 99999,
        maxDigits: 5,
        containerClassName: 'max-w-[200px]',
    },
}

export const getTableRangeFilterConfig = (
    columnId: string
): TableRangeFilterConfig | undefined => {
    return TABLE_RANGE_FILTER_CONFIG[
        columnId as keyof typeof TABLE_RANGE_FILTER_CONFIG
    ]
}
